import {DateTime} from "luxon";

export const INVENTORY_TYPE = {
    RUPTURE: 'rupture',
    INACTIVE: 'inactive',
    WARNING: 'warning'
}

export const INVENTORY_TYPE_LABEL = {
    [INVENTORY_TYPE.RUPTURE]: 'Rupture de stock',
    [INVENTORY_TYPE.INACTIVE]: 'Non vendu depuis une periode',
    [INVENTORY_TYPE.WARNING]: 'Seuil atteint'
}

// export const INVENTORY_TYPE_HASTOBUY = {

// }

export const INVENTORY_FILTER_DEFAULT = {
    type: INVENTORY_TYPE.RUPTURE,
    warehouse: 'Dekon',
    hasToBuy: true,
    startDate: DateTime.local().minus({days: 90}).toJSDate()
}